import URL from '@/api/URL'
import fetch from '@/api/fetch'

export function getBuyList(params) {
	return fetch.post(URL.getBuyList, params)
}

export function sendBuyWarning(params) {
	return fetch.post(URL.sendBuyWarning, params)
}

export function getBuyDetail(params) {
	return fetch.post(URL.getBuyDetail, params)
}

export function getBuyHistoryList(params) {
	return fetch.post(URL.getBuyHistoryList, params)
}

export function buyService(params) {
	return fetch.post(URL.buyService, params)
}

export function updateBuyWarning(params) {
	return fetch.post(URL.updateBuyWarning, params)
}



// WEBPACK FOOTER //
// ./src/api/modules/costAdmin.js